import templateStr from 'text!./policy-summary.html';
import PolicyLandingUtil from 'edge/gateway/util/policylanding/PolicyLandingUtil';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            gwPolicySummary: '=',
            showAccount: '=',
            showPremium: '=',
            noResultsMessage: '@'
        },
        controller: ['$scope', function ($scope) {
            var now = new Date().getTime();
            $scope.getPolicyTypeIcon = PolicyLandingUtil.getPolicyTypeIcon;
            $scope.isActive = function (line) {
                return new Date(line.effective).getTime() < now;
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/PolicySummaryDirective/PolicySummary.js
// module id = 1759
// module chunks = 0